/*
 * BulkImportManager constants
 */

export const REDUCER_KEY = 'bulkImport';

// Main Action Constants
export const UPLOAD_FILE = 'app/BulkImport/UPLOAD_FILE';
export const UPLOAD_FILE_PROGRESS = 'app/BulkImport/UPLOAD_FILE_PROGRESS';
export const ANALYZE_FILE = 'app/BulkImport/ANALYZE_FILE';
export const GET_REQUIRED_FIELDS = 'app/BulkImport/GET_REQUIRED_FIELDS';
export const CREATE_IMPORT_JOB = 'app/BulkImport/CREATE_IMPORT_JOB';

// WebSocket Constants
export const WEBSOCKET_CONNECT = 'app/BulkImport/WEBSOCKET_CONNECT';
export const WEBSOCKET_STATUS = 'app/BulkImport/WEBSOCKET_STATUS';

// Job Progress Constants (WebSocket events)
export const JOB_PROGRESS = 'app/BulkImport/JOB_PROGRESS';

// Column Mapping Constants
export const UPDATE_COLUMN_MAPPING = 'app/BulkImport/UPDATE_COLUMN_MAPPING';
export const CLEAR_COLUMN_MAPPING = 'app/BulkImport/CLEAR_COLUMN_MAPPING';

// Navigation Constants
export const SET_CURRENT_STEP = 'app/BulkImport/SET_CURRENT_STEP';
export const GO_TO_NEXT_STEP = 'app/BulkImport/GO_TO_NEXT_STEP';

// Reset Constants
export const RESET_ALL = 'app/BulkImport/RESET_ALL';

// Utility Constants
export const CLEANUP = 'app/BulkImport/CLEANUP';

export const SELECT_IMPORT_TYPE = 'app/BulkImport/SELECT_IMPORT_TYPE';

// Import Type Constants
export const IMPORT_TYPE_BIB_NUMBER = 'bulk_bib_number_import';
export const IMPORT_TYPE_MEDICAL_CERTIFICATE =
  'bulk_medical_certificate_import';

// Upload Configuration
export const CHUNK_SIZE = 1024 * 1024; // 1MB chunks
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB max
export const UPLOAD_STATUS_POLL_INTERVAL = 1000; // 1 second
